import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/freight/invoice/web/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

export function detailInfo(invoiceId) {
  return request.send({
    url: `/pmy/freight/invoice/web/detail?invoiceId=${invoiceId}`,
    method: "get"
  });
}
export function getOwnerOverview(data) {
  return request.send({
    url: `/pmy/freight/invoice/web/overview`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

export function handleInvoice(data) {
  return request.send({
    url: `/pmy/freight/invoice/web/handle`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
